module.exports = __webpack_public_path__ + "fonts/icomoon.ba82f1ab.553045e.ttf";